module.exports = __webpack_public_path__ + "assets/gudingzichan.0f8a8b06.svg";